import { Badge as AntdBadge } from 'antd'
import { BadgeProps as AntdBadgeProps } from 'antd/lib/badge'
import { FC } from 'react'
import styled from 'styled-components'

import { themeColor } from '../theme'
import { ThemeWrapper } from '../theme/themeWrapper'

const StyledBadge = styled(AntdBadge)`
  .ant-badge-count {
    background: ${themeColor('primary')} !important;
  }
`

export type BadgeProps = AntdBadgeProps

export const Badge: FC<BadgeProps> = props => (
  <ThemeWrapper>
    <StyledBadge {...props} />
  </ThemeWrapper>
)
